export function normalizeFillImageUrl (url, protocol = window.location.protocol) {
  if (!url) return ''
  let normalized = String(url)
  if (normalized.includes('p.ananas.chaoxing.com')) {
    normalized = normalized.replace('p.ananas.chaoxing.com', 'museum.chaoxing.com')
  }
  if (normalized.includes('p.cldisk.com')) {
    normalized = normalized.replace('p.cldisk.com', 'museum.chaoxing.com')
  }
  const protocolMatch = normalized.match(/^\w+:\/\//)
  if (protocolMatch && protocolMatch[0].indexOf(protocol) !== 0) {
    normalized = normalized.replace(protocolMatch[0].slice(0, -2), protocol)
  }
  return normalized
}

export function getFillImageUrl (form, fileImageList, protocol = window.location.protocol) {
  let imgUrl = ''
  if (form.fillimageindex === '') {
    const uploaded = Array.isArray(form.fillimage) ? form.fillimage[0] : null
    imgUrl = uploaded ? (uploaded.http || uploaded.fileUrl) : ''
  } else {
    const index = Number(form.fillimageindex) - 1
    imgUrl = fileImageList[index] ? fileImageList[index].url : ''
  }
  if (!imgUrl) throw new Error('未选择填充图片')
  return normalizeFillImageUrl(imgUrl, protocol)
}

export function clampClipSize (width, height, maxSize = 2048, minSize = 1) {
  const sourceWidth = Math.max(minSize, Math.round(width))
  const sourceHeight = Math.max(minSize, Math.round(height))
  const scale = Math.min(1, maxSize / Math.max(sourceWidth, sourceHeight))
  return {
    width: Math.max(minSize, Math.round(sourceWidth * scale)),
    height: Math.max(minSize, Math.round(sourceHeight * scale)),
    scale
  }
}

export function coordinateToClipPixel (coordinate, extent, clipSize) {
  const width = extent[2] - extent[0]
  const height = extent[3] - extent[1]
  return [
    ((coordinate[0] - extent[0]) / width) * clipSize.width,
    ((extent[3] - coordinate[1]) / height) * clipSize.height
  ]
}

export function getImageDrawRect (clipExtent, imageExtent, clipSize) {
  const leftTop = coordinateToClipPixel([imageExtent[0], imageExtent[3]], clipExtent, clipSize)
  const rightBottom = coordinateToClipPixel([imageExtent[2], imageExtent[1]], clipExtent, clipSize)
  return {
    dx: leftTop[0],
    dy: leftTop[1],
    dw: rightBottom[0] - leftTop[0],
    dh: rightBottom[1] - leftTop[1]
  }
}
